(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tiaro-bundle-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tiaro-bundle-products')) {
  class TiaroBundleProducts extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('product-form')?.querySelector('form');
      this.mainPrice = Number(this.dataset.mainPrice) || 0;
      this.onVariantChange = (event) => {
        if (event.detail?.sectionId !== this.dataset.sectionId) return;
        this.mainPrice = Number(event.detail.variant?.price) || 0;
        this.update();
      };
      this.onQuantityChange = () => this.update();
      document.addEventListener('product:variant-change', this.onVariantChange);
      this.form?.querySelector('[name="quantity"]')?.addEventListener('input', this.onQuantityChange);
      this.form?.querySelector('[name="quantity"]')?.addEventListener('change', this.onQuantityChange);
      this.addEventListener('change', this.onQuantityChange);
      this.update();
    }
    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariantChange);
      this.form?.querySelector('[name="quantity"]')?.removeEventListener('input', this.onQuantityChange);
      this.form?.querySelector('[name="quantity"]')?.removeEventListener('change', this.onQuantityChange);
      this.removeEventListener('change', this.onQuantityChange);
    }
    quantity() {
      return Math.max(1, Number(this.form?.querySelector('[name="quantity"]')?.value) || 1);
    }
    selectedVariant(row) {
      const input = row.querySelector('[data-bundle-variant]');
      if (input.tagName === 'SELECT') {
        const option = input.selectedOptions[0];
        return { id: Number(option.value), price: Number(option.dataset.price) || 0 };
      }
      return { id: Number(input.value), price: Number(input.dataset.price) || 0 };
    }
    getSelectedItems(quantity = this.quantity()) {
      return Array.from(this.querySelectorAll('[data-bundle-row]'))
        .filter((row) => row.querySelector('[data-bundle-check]').checked)
        .map((row) => ({ id: this.selectedVariant(row).id, quantity }));
    }
    money(cents) {
      const locale = this.dataset.locale || 'ja-JP';
      const currency = this.dataset.currency || 'JPY';
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    }
    update() {
      const quantity = this.quantity();
      let total = this.mainPrice * quantity;
      let index = 1;
      const additionalItems = [];
      this.querySelectorAll('[data-bundle-row]').forEach((row) => {
        const variant = this.selectedVariant(row);
        row.querySelector('[data-bundle-price]').textContent = this.money(variant.price);
        if (row.querySelector('[data-bundle-check]').checked) {
          total += variant.price * quantity;
          for (const [field, value] of [['id', variant.id], ['quantity', quantity]]) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `shopify-additional-items[${index}][${field}]`;
            input.value = String(value);
            additionalItems.push(input);
          }
          index += 1;
        }
      });
      this.querySelector('[data-bundle-total]').textContent = this.money(total);
      this.querySelector('[data-bundle-express-items]').replaceChildren(...additionalItems);
    }
  }
  customElements.define('tiaro-bundle-products', TiaroBundleProducts);
}
  } catch(e) { console.error(e); }
})();

})();
